<template>
  <div class="sidebar" v-show="toggleSidebar">
    <div class="sidebar-wrapper" id="style-3">
      <ul class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot name="links">
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="index"
                        :to="link.path"
                        :name="link.name"
                        :icon="link.icon">
          </sidebar-link>
        </slot>
        <li class="nav-item">
          <a :href="`https://admin.bookimed${domainType}/agencies/index`" class="nav-link" target="_blank">
            <i class="tim-icons icon-bank"></i><p>Partners</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import SidebarLink from "./SidebarLink";

  export default {
    props: {
      sidebarLinks: {
        type: Array,
        default: () => []
      },
    },
    provide() {
      return { autoClose: false };
    },
    computed: {
      domainType() {
        return window.location.hostname.slice(window.location.hostname.lastIndexOf('.'));
      },
      toggleSidebar() {
        return this.$sidebar.showSidebar;
      },
    },
    components: {
      SidebarLink
    },
  };
</script>
